module.exports = __webpack_public_path__ + "img/United Nations.2bd8b581.svg";